<section
  class="forgot-password-section container-fluid sts-section sts-form" tabindex="0">


  <app-sts-section-header key="sts-forgot-password-header" [errors]="errors">Sign In
  </app-sts-section-header>

  <app-sts-section-body key="sts-forgot-password-body">
    <!-- content is served by CMS -->
  </app-sts-section-body>

  <form (ngSubmit)="captcha.submit()" autocomplete="off"
        class="sts-form animate-all"
        *ngIf="!isInTheDecisionFlow">

    <div class="row">
      <div class="col-24
      forgot-instruction-bottom"
           app-sts-cms-txt
           key="sts-enter-your-userid-for-reset">
        Please enter your user ID
        and select <span class="bold">Next</span>.
      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <div class="sts-label-row">
          <label for="userId" app-sts-cms-txt key="sts-user-id">
            User ID:
          </label>
        </div>
        <div class="sts-input-row">
          <input type="text"
                 class="sts-textbox"
                 id="userId"
                 name="userId"
                 [ngClass]="{'has-errors': !usernameValid}"
                 [(ngModel)]="stsUser.userName"
                 aria-required="true"/>
          <app-sts-show-error key="sts-field-error-userid-required"
                              description="User ID is a required field"
                              [show]="!usernameValid"></app-sts-show-error>
        </div>


        <div>
          <div style="margin-bottom: 10px; padding-top: 10px;">
            <app-sts-captcha (onValidate)="onSubmit($event)"></app-sts-captcha>
          </div>
        </div>

        <div>
            <button app-sts-cms-txt key="sts-cancel-button"
                    class="sts-btn other-sts-btn"
                    type="button"
                    (click)="gotoHome()">
              Cancel
            </button>
            <app-sts-button key="sts-next-button">
              Next
            </app-sts-button>
        </div>
      </div>
    </div>
  </form>

  <div class="container-fluid animate-all" *ngIf="isInTheDecisionFlow">

    <div class="row">
      <div class="col-24">
        <p app-sts-cms-txt key="sts-please-choose-recovery-option-text">
          Please select a recovery option you prefer from the list below:
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-24">
        <button class="sts-btn" app-sts-cms-txt
                key="sts-reset-by-email-text" type="button"
                (click)="handleChoice('email')">Send a Recovery Email
        </button>
        <button *ngIf="securityQuestionsActive && securityQuestionsAnswered" class="sts-btn forgot-password-text-align"
          app-sts-cms-txt key="sts-reset-by-questions-text" type="button" (click)="handleChoice('questions')">
          Let me Answer Security Questions
        </button>
      </div>
    </div>

  </div>


</section>
